import { contentTypeLabel, readCount } from './rows';

/**
 * The records export: the scope the page holds them under, then one line per record in the current
 * filter, as returned.
 *
 * The head says which property, which filter, how many of the returned records it kept and when
 * they were fetched, so the file still says what it is once it leaves the page. Values are Google's
 * own — raw timestamps and flags — and an absent one is "Not returned" in words, never an empty cell
 * or a zero that whoever opens the file could total.
 */
export function buildRecordsCsv({ t, scope, filterLabel, fetchedAt, rows, returned }) {
    const notReturned = t('tools.gsc.not_returned');
    const value = (field) => (field === undefined || field === null ? notReturned : field);
    const count = (field) => readCount(field) ?? notReturned;

    const contents = (sitemap) =>
        sitemap.contents?.length
            ? sitemap.contents
                  .map(
                      (content) =>
                          `${contentTypeLabel(t, content.type)}: ${count(content.submitted)}`,
                  )
                  .join('; ')
            : notReturned;

    return [
        [t('tools.gsc.exports.property'), scope.siteUrl],
        [t('tools.sitemap_status.export.filter'), filterLabel],
        [t('tools.sitemap_status.export.records'), `${rows.length} / ${returned}`],
        [t('tools.gsc.exports.fetched_at'), fetchedAt ?? ''],
        [t('tools.sitemap_status.export.note')],
        [],
        [
            'path',
            'type',
            'isSitemapsIndex',
            'isPending',
            'lastSubmitted',
            'lastDownloaded',
            'warnings',
            'errors',
            t('tools.sitemap_status.export.submitted_by_type'),
        ],
        ...rows.map(({ sitemap }) => [
            value(sitemap.path),
            value(sitemap.type),
            value(sitemap.isSitemapsIndex),
            value(sitemap.isPending),
            value(sitemap.lastSubmitted),
            value(sitemap.lastDownloaded),
            count(sitemap.warnings),
            count(sitemap.errors),
            contents(sitemap),
        ]),
    ];
}
